import r from "react";
import { s as l } from "../grid.module-BaK_X3T2.mjs";
const m = r.forwardRef(
  ({ children: e, className: o = "", dataTestId: s = null, style: a, as: t = "div", ...d }, i) => r.createElement(
    t,
    {
      className: `${l.grid__row} grid-row fuse-responsive-grid__row ${o}`,
      "data-test-id": s,
      ref: i,
      style: a,
      ...d
    },
    e
  )
);
m.displayName = "GridRow";
export {
  m as GridRow
};
